export function getImageRatio(asset: {
  width: number;
  height: number;
}): number {
  return asset.width / asset.height;
}
